import { alpha } from '@mui/material/styles';

export default function Input(theme) {
  const primary = theme.palette.primary;
  return {
    MuiInputBase: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          '&.Mui-disabled': { '& svg': { color: theme.palette.text.disabled } },
        },
        input: {
          '&::placeholder': { opacity: 1, color: theme.palette.text.disabled },
        },
      },
    },
    MuiOutlinedInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          background: '#fff',
          transition: 'box-shadow 0.2s ease',
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#E2E8F0',
            transition: 'border-color 0.2s',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': { borderColor: '#CBD5E1' },
          '&.Mui-focused': {
            boxShadow: `0 0 0 3px ${alpha(primary.main, 0.12)}`,
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: primary.main,
              borderWidth: 1.5,
            },
          },
          '&.Mui-disabled': {
            background: '#F8FAFC',
            '& .MuiOutlinedInput-notchedOutline': { borderColor: theme.palette.action.disabledBackground },
          },
        },
      },
    },
    MuiFilledInput: {
      styleOverrides: {
        root: {
          borderRadius: 10,
          backgroundColor: '#F1F5F9',
          '&:hover': { backgroundColor: '#E2E8F0' },
          '&.Mui-focused': { backgroundColor: '#F1F5F9' },
        },
        underline: { '&:before': { borderBottomColor: '#CBD5E1' } },
      },
    },
    MuiInput: {
      styleOverrides: {
        underline: { '&:before': { borderBottomColor: '#CBD5E1' } },
      },
    },
    MuiTextField: { defaultProps: { size: 'small' } },
  };
}
